import React from 'react';
import { Tooltip } from 'antd';

/** Список букв */
export const Letters = ({letters, selected, onChangeLetter, chars}) => {
  return (
    <div className="filter_abc_div abc_div active">
      {letters.map((letter, i) => {
          if (typeof chars[letter] === 'undefined') 
            return <a key={i} className= "letter" style={{pointerEvents: "none", cursor: "default", color:"#DCDCDC"}}>{letter}</a>;
          const isChecked = (selected)? selected.filter(item => item.letter==letter).length>0: false;
          return <a key={i} style={{"color": "#6f9818"}} onClick={(e)=> onChangeLetter(isChecked, letter, e)} className={(isChecked)?"active letter":"letter"}>{letter}</a>
        }
      )}
    </div>            
  )
}


/** Список букв c колчеством значений 
 * letters массив [{ letter, count }]
*/
export const LettersCounter = ({letters, selected, onChangeLetter, chars}) => {
  return (
    <div className="filter_abc_div abc_div active">
      {letters.map(({letter, count}, i) => {
          if (typeof chars[letter] === 'undefined') 
            return <a key={i} className= "letter" style={{pointerEvents: "none", cursor: "default", color:"#DCDCDC"}}>{letter}</a>;
          const isChecked = (selected)? selected.filter(item => item===letter).length>0: false;
          return <Tooltip placement="top" title={count}><a key={i} style={{"color": "#6f9818"}} onClick={(e)=> onChangeLetter(letter, e)} className={(isChecked)?"active letter":"letter"}>{letter}</a></Tooltip>
        }
      )}
    </div>            
  )
}
